const Footer = () => {
  return (
    <div className="flex justify-center pb-10">
      <h1 className="text-lg">Proudly Canadian 🇨🇦 </h1>
    </div>
  );
};

export default Footer;
